import { chartColors } from './colors'

class ColorService {
  pickNextBestColor ({ usedColors = [], cachedColor, nextIndex = 0 } = {}) {
    let color
    const getNextColor = () => {
      return chartColors[nextIndex++ % chartColors.length]
    }

    if (usedColors.length >= chartColors.length) {
      // We've already used up all the colors, just pick the next one
      color = getNextColor()
    } else if (cachedColor && !usedColors.includes(cachedColor)) {
      // Cached color is unused
      color = cachedColor
    } else {
      // There are still more available colors, find the next one
      for (let i = 0; i < chartColors.length; i++) {
        const nextColor = getNextColor()
        if (!usedColors.includes(nextColor)) {
          color = nextColor
          break
        }
      }
    }

    return { color, nextIndex }
  }
}

export const colorService = new ColorService()
